import { render, staticRenderFns } from "./PharmacyDrugForm.vue?vue&type=template&id=01dd9032&scoped=true"
import script from "./PharmacyDrugForm.vue?vue&type=script&lang=js"
export * from "./PharmacyDrugForm.vue?vue&type=script&lang=js"
import style0 from "./PharmacyDrugForm.vue?vue&type=style&index=0&id=01dd9032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd9032",
  null
  
)

export default component.exports